import { Autocomplete, Grid, Menu, MenuItem, TextField, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import styles from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss'; 
import globalStyles from './../../../assets/styles/global.module.scss'
import { getChatbotVersionInfo, isCurrentViewVersionPublished } from '../flowBuilder/utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';
import CheckIcon from '@mui/icons-material/Check';
import GlobalButton from '../../utility/globalButton/button';
import { ACTION_TYPE_NAME, getUpdatedValueOfNodesForCurrentActiveStaticWorkflow, isCatalogTemplate, isCurrentChatbotPublishedorPaused, isFlowTemplate, isSendOrderPaymentInfoSystemAPIExist, onClickOfQRCode } from '../flowBuilder/flowBuilderConstants';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { chatbotIntegratedChannelDeploymentInstagramObj, chatbotIntegratedChannelDeploymentObj, chatbotVersionInfoInterface } from '../../../models/axiosModel';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../context/flowBuilderContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import QRimage from '../../../assets/chatbotAssets/QRimage.png'
import GlobalTooltip from '../../utility/tooltip/globalTooltip';
import IconsColor from '../../utility/iconsColor';
import { primaryColor } from '../../../utils/colors';
import { useFlowBuilderStore } from '../../../store/flowBuilderStore';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getDeploymentTriggerPayload } from '../../../models/flowBuilderTypes';
import GlobalPopUp from '../../utility/globalPopUp';
import CustomVariableTable from '../flowBuilder/customVariableTable';
import ImportRuleBasedChatbotPopup from './importRuleBasedChatbotPopup';
import MissingSaveVariableActionValidationPopup from '../flowBuilder/missingSaveVariableActionValidationPopup';
import DeletePostDeploymentTriggerWarningPopup from '../flowBuilder/deletePostDeploymentTriggerWarningPopup';
import agent from '../../../services/api';
import ResetChatConfirmationPopup from '../flowBuilder/resetChatConfirmationPopup';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { CHATBOT_CHANNEL_NAME, isInstagramChannel, isWhatsAppChannel } from '../../../pages/ruleBasedInbox/channelConstants';

const WorkflowActionBlock = () => {
    
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()
    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const { flagHideArrows, setFlagHideArrows, GetCustomVariableListApi, GetMetaDataVariableListApi, getChatbotTriggerConfigApi } = useFlowBuilderStore(useShallow((state) => ({
        flagHideArrows: state.flagHideArrows,
        setFlagHideArrows: state.setFlagHideArrows,
        GetCustomVariableListApi: state.GetCustomVariableListApi,
        GetMetaDataVariableListApi: state.GetMetaDataVariableListApi,
        getChatbotTriggerConfigApi: state.getChatbotTriggerConfigApi,
    })))

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow, getWorkflowDetails, setFlagShowQRCodePopup, setPhoneNumberQR, setConditionGroup, setQrChannelName, isProcessing } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { nodes, edges, getChatbotPostDeploymentTriggerApi, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload;
    
    const whatsAppChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined;
    const instagramChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentInstagramObj | undefined;

    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isWhatsApp = isWhatsAppChannel(channelName);
    const isInstagram = isInstagramChannel(channelName);

    const [saveState, setSaveState] = useState<"idle" | "saving" | "saved">("idle");
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
    const [flagCustomVariableTablePopup, setFlagCustomVariableTablePopup] = useState<boolean>(false);
    // const [flagFlowValidationInStep, setFlagFlowValidationInStep] = useState<boolean>(false);
    const [flagValidationWarningInStep, setFlagValidationWarningInStep] = useState<boolean>(false);
    const [flagMissingTemplateActionWarning, setFlagMissingTemplateActionWarning] = useState<boolean>(false);

    const [listOfInvalidFlowValidationStep, setListOfInvalidFlowValidationStep] = useState<any[]>([]);
    const [flagDeletePostDeploymentTriggerWarning, setFlagDeletePostDeploymentTriggerWarning] = useState<boolean>(false);
    const [listOfDeletedSteps, setListOfDeletedSteps] = useState<getDeploymentTriggerPayload[]>([]);
    const [flagResetChatConfirmationPopup, setFlagResetChatConfirmationPopup] = useState<boolean>(false);    

    const [flagShowImportChatbotPopup, setFlagShowImportChatbotPopup] = useState<boolean>(false);

    const hasNodes = useMemo(
        () => (nodes?.length > 1),
        [nodes]
    );
    
    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch((err) => {
                console.error(`Error attempting to enable fullscreen: ${err.message}`);
            });
        } else {
            document.exitFullscreen()
        }
    }; 

    const syncTemplateAndCustomApis = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let workflow_id = searchParams.get('workflow_id')
        if (workflow_id) {
            const response = await getWorkflowDetails(workflow_id);
            if (!(response.status)) {
                handleError(response);
            } else {
                showSuccess("Successfully Synced new templates and custom apis.")
            }
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const actionMenuItemForWorkflow = [
        {
            label: document.fullscreenElement ? "Exit Full Screen" : "Full Screen", 
            action: () => {
                toggleFullscreen();
            }, 
            isDisable: false,
        },
        {
            label: flagHideArrows ? "Overlay Edges" : "Underlay Edges", 
            action: () => {
                setFlagHideArrows(!flagHideArrows);
            },
            isDisable: false,
        },
        {
            label: "Custom Variables", 
            action: () => {
                setFlagCustomVariableTablePopup(true);
            },
            isDisable: false,
        },
        ...((isWhatsApp && !isCurrentViewVersionPublished(currentActiveStaticWorkflow)) ? [
            {
                label: "Import Chatbot", 
                action: () => {
                    setFlagShowImportChatbotPopup(true);
                },
                isDisable: hasNodes,
                disabledReason: "Remove all steps before importing a chatbot.",
            },
        ] : []),
        {
            label: <>
                <Grid item className={`${globalStyles.displayFlex} ${globalStyles.alignItemCenter}`} gap={"5px"}>
                    Sync
                    <GlobalTooltip
                        arrow
                        placement='bottom'
                        title={`Sync to load any ${isWhatsApp ? "new templates or" : ""} API changes made outside this chatbot.`}
                    >
                        <Grid item sx={{ display: "flex", cursor: "pointer"}} >
                            <IconsColor fillColor={primaryColor} iconName="info" height={"16"} width={"16"} />
                        </Grid>
                    </GlobalTooltip>
                </Grid>
            </>, 
            action: async () => await syncTemplateAndCustomApis(), 
            isDisable: false,
        },
    ] 

    const getVersionValue = (isMobileScreen: boolean) => {
        if(currentActiveStaticWorkflow){
            if(currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase() == "draft"){
                return isMobileScreen ? "Published Version" : "Draft Version";
            } else {
                return isMobileScreen ? "Draft Version" : "Published Version";
            }
        }
        return isMobileScreen ? "Published Version" : "Draft Version";
    }

    const checkDisablePublishButton = () => {
        if (isWhatsApp && whatsAppChannel?.waba_name && (whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.length ?? 0) > 0) {
            return false;
        }
        if(isInstagram && instagramChannel?.instagram_account_name && instagramChannel?.meta_integration_instagram_id && instagramChannel?.integrated_channel_id) {
            return false;
        }
        return true;
    }

    const handleOpenQRCode = () => {
        const conditionGroupOfChatbot = currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version?.chatbot_version_status_name?.toLowerCase() == "published")?.chatbot_step_deployment_trigger_data?.[0]?.condition_group ?? null;
        const qrValue = isInstagram
            ? (instagramChannel?.instagram_account_name ?? "")
            : (whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.[0]?.display_phone_number ?? "");
        onClickOfQRCode(
            qrValue,
            conditionGroupOfChatbot,
            setFlagShowQRCodePopup,
            setPhoneNumberQR,
            setConditionGroup,
            setQrChannelName,
            isInstagram ? CHATBOT_CHANNEL_NAME.INSTAGRAM : CHATBOT_CHANNEL_NAME.WHATSAPP
        );
    }

    const actionMenuItemForMobileScreen = [
        {
            label: getVersionValue(true),
            action: () => {
                onChangeOfVersion(getVersionValue(true));
            }, 
            isDisable: false,
        },
        {
            label: "Go Live",
            action: () => {
                onClickOfPublishBtn();
            }, 
            isDisable: isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisablePublishButton() || saveState === "saving",
        },
        ...((isCurrentChatbotPublishedorPaused(currentActiveStaticWorkflow)) ? 
            [{
                label: "QR Code",
                action: () => {
                    handleOpenQRCode();
                },  
                isDisable: false,
            }]
            : []
        ),
        ...(actionMenuItemForWorkflow),
    ]

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const onChangeOfVersion = (value: string) => {
        setCurrentActiveStaticWorkflow((prevState: any) => ({ 
            ...prevState, 
            currentViewVersion: value?.toLowerCase() == "draft version" ? "Draft" : "Published", 
            ...(value?.toLowerCase() == "published version" && {
                chatbot_version_info: prevState?.chatbot_version_info?.map((version: chatbotVersionInfoInterface) => {
                    if(version?.chatbot_version_status_name?.toLowerCase() == "draft"){
                        return {
                            ...version, 
                            chatbot_step_data: [...(version?.chatbot_step_data?.filter((step) => step?.chatbot_step_name?.toLowerCase() == "redeploy" || step?.chatbot_step_name?.toLowerCase() == "redeploy chatbot")), ...getUpdatedValueOfNodesForCurrentActiveStaticWorkflow(nodes, edges, searchParams.get('workflow_id') || "")]
                        }
                    }
                    return version;
                })
            }) 
        })) 
    }

    const getChatbotPostDeploymentTriggerApiCall = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getChatbotPostDeploymentTriggerApi(searchParams.get('workflow_id') || ""); 
        if(!res.status){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
        return res?.data?.filter((data: any) => data?.chatbot_post_deployment_trigger_type?.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "keyword") || null;
    }

    const onClickOfPublishBtn = async () => {
        let flagFlowValidationWarning = false; 
        let listOfInvalidStep: any[] = [];
        let flagMissingTemplateActionWarning = false;
        
        nodes?.forEach((node: any) => {

            const dataWithFlowTemplate = Array.isArray(node?.data) && node?.data?.find((data: any) => data?.action_type?.action_type_name == ACTION_TYPE_NAME['TEMPLATE'] && isFlowTemplate(currentActiveStaticWorkflow, data?.action_data?.whatsapp_template?.whatsapp_template_id)); 
            const dataWithCatalogTemplate = Array.isArray(node?.data) && node?.data?.find((data: any) => data?.action_type?.action_type_name == ACTION_TYPE_NAME['TEMPLATE'] && isCatalogTemplate(currentActiveStaticWorkflow, data?.action_data?.whatsapp_template?.whatsapp_template_id)); 
            const isSendOrderPaymentSystemAPIExist = Array.isArray(node?.data) && isSendOrderPaymentInfoSystemAPIExist(nodes, node?.id, currentActiveStaticWorkflow);

            const dataWithFlowSaveVariable = Array.isArray(node?.data) && node?.data?.find((data: any) => data?.action_type?.action_type_name == ACTION_TYPE_NAME['SAVE_DATA'] && Array.isArray(data?.action_data) &&  data?.action_data?.find((action: any) => action?.action_data?.value_type == "user_flow_message_payload" && action?.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id));
            
            if((dataWithFlowTemplate && !dataWithFlowSaveVariable) && !flagMissingTemplateActionWarning){
                flagFlowValidationWarning = true;
                listOfInvalidStep.push(node);
            }

            if(((!dataWithFlowTemplate && !dataWithCatalogTemplate && !isSendOrderPaymentSystemAPIExist) && dataWithFlowSaveVariable) && !flagFlowValidationWarning){
                flagMissingTemplateActionWarning = true;
                listOfInvalidStep.push(node);
            }
        }); 

        if(flagFlowValidationWarning || flagMissingTemplateActionWarning){
            setFlagValidationWarningInStep(true);
            if(flagMissingTemplateActionWarning){
                setFlagMissingTemplateActionWarning(true);
            } 
            setListOfInvalidFlowValidationStep(listOfInvalidStep);
        } else {
            if(getChatbotVersionInfo(currentActiveStaticWorkflow).status.toLowerCase() == "published"){
                const data:getDeploymentTriggerPayload[] | null = await getChatbotPostDeploymentTriggerApiCall();
                let flagDeletePostDeploymentTrigger = false; 
                let listOfDeletedStep: getDeploymentTriggerPayload[] = [];
                if(data){
                    data?.forEach((trigger: getDeploymentTriggerPayload) => {
                        if(trigger?.chatbot_step && !["redeploy chatbot", "redeploy step"]?.includes(trigger?.chatbot_step?.chatbot_step_name?.toLowerCase() || "")){
                            if(!nodes?.find((node: any) => node.id == trigger?.chatbot_step?.chatbot_step_id)){
                                flagDeletePostDeploymentTrigger = true;
                                listOfDeletedStep.push(trigger);
                            }
                        }
                    });
                }
                if(flagDeletePostDeploymentTrigger){
                    setFlagDeletePostDeploymentTriggerWarning(true); 
                    setListOfDeletedSteps(listOfDeletedStep);
                } else {
                    setFlagResetChatConfirmationPopup(true);
                }
            } else {
                setFlagResetChatConfirmationPopup(true);
            }
        }
    } 

    async function getCurrentActiveWorkflowDetails() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const workflow_id = searchParams.get('workflow_id');
        if (!workflow_id) {
            navigate('/workflow');
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
            return;
        }

        try {
            const workflowPromise = getWorkflowDetails(workflow_id);

            const otherPromises: any[] = [GetCustomVariableListApi(workflow_id), GetMetaDataVariableListApi(), getChatbotTriggerConfigApi(workflow_id)];

            const [workflowResponse] = await Promise.all([workflowPromise, ...otherPromises]);

            if (workflowResponse?.status && workflowResponse?.data) {
                // generateNodesAndEdges(workflowResponse.data[0]);
            } else {
                handleError(workflowResponse);
                navigate('/workflow');
            }
        } catch (error) {
            console.error("Error in getCurrentActiveWorkflowDetails:", error);
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    const updatePublishTimeStamp = () => {
        setCurrentActiveStaticWorkflow((prev) => {
            if (!prev) return prev;

            const draftVersion = prev.chatbot_version_info?.find((item) => item?.chatbot_version_status_name?.toLowerCase() === "draft");

            if (!draftVersion) return prev;

            const publishedIndex = prev.chatbot_version_info.findIndex((item) => item?.chatbot_version_status_name?.toLowerCase() === "published");

            const chatbot_version_info = [...prev.chatbot_version_info];

            const currentTimestamp = new Date().toISOString();
            if (publishedIndex === -1) {
                // No published version exists, create one from draft
                chatbot_version_info.push({
                    ...draftVersion,
                    chatbot_version_status_name: "Published",
                    timestamp: currentTimestamp,
                });
            } else {
                // Update existing published version with latest draft data
                chatbot_version_info[publishedIndex] = {
                    ...draftVersion,
                    chatbot_version_status_name: "Published",
                    timestamp: currentTimestamp,
                };
            }

            return {
                ...prev,
                chatbot_version_info,
            };
        });
    }

    async function publishChatbot(flagReset: boolean) {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let chatbot_id = currentActiveStaticWorkflow?.chatbot_id || ""
        const response = await agent.publishChatbot.post(chatbot_id, flagReset)
        if (response.status) {
            showSuccess("Chatbot published successfully!")
            updatePublishTimeStamp();
            getCurrentActiveWorkflowDetails();
        } else {
            handleError(response)
        }
        setFlagResetChatConfirmationPopup(false);
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        if (isProcessing.current) {
            setSaveState("saving");
            if (timerRef.current) clearTimeout(timerRef.current);
        } else if (!isProcessing.current && saveState === "saving") {
            setSaveState("saved");

            timerRef.current = setTimeout(() => {
                setSaveState("idle");
            }, 1000);
        }
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [isProcessing.current]); 

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "F11") {
                e.preventDefault();
                toggleFullscreen();
            }
        };

        if(window.location.pathname?.toLowerCase() == "workflow/staticworkflowdetails"){
            window.addEventListener("keydown", handleKeyDown);
            return () => window.removeEventListener("keydown", handleKeyDown);
        }
    }, [])

    return (
        <>
            <Grid item>
                <Grid container gap={breakPoints.smallScreen ? "8px" : "20px"} alignItems={"center"}>
                    <Grid item className={styles.savingVariable}>
                        {
                            isCurrentViewVersionPublished(currentActiveStaticWorkflow) ?
                                "View Mode"
                                :
                                <>
                                    {saveState === "saving" && "Saving..."}
                                    {saveState === "saved" && (
                                        <Grid container alignItems={"center"} gap="6px">
                                            <Grid item className={globalStyles.displayFlex}>
                                                <CheckIcon />
                                            </Grid>
                                            <Grid item>Saved</Grid>
                                        </Grid>
                                    )}
                                </>
                        }
                    </Grid>
                    {!breakPoints.smallScreen && 
                        <>
                            <Grid item>
                                <Autocomplete
                                    sx={{ minWidth: "170px" }}
                                    className={globalStyles.autocompleteParaphrasing}
                                    value={getVersionValue(false)}
                                    options={['Draft Version', 'Published Version']}
                                    onChange={(e, value) => onChangeOfVersion(value)}
                                    renderInput={(params) => <TextField {...params} placeholder='Select Version...' />}
                                    disableClearable
                                />
                            </Grid>

                            <Grid item>
                                <GlobalButton
                                    buttonText={"Go Live"}
                                    className='primaryButtonStyle'
                                    sx={{ width: "120px", padding: "6px 20px" }}
                                    onClick={() => onClickOfPublishBtn()}
                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisablePublishButton() || saveState === "saving"}
                                />
                            </Grid>

                            {isCurrentChatbotPublishedorPaused(currentActiveStaticWorkflow) && 
                                <Grid item>
                                    <img 
                                        alt="qr_image" 
                                        src={QRimage} 
                                        height={"24"} 
                                        width={"24"} 
                                        className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`} 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenQRCode();
                                        }} 
                                    />
                                </Grid>
                            }
                        </>
                    }

                    <Grid item>
                        <MoreVertIcon
                            className={`${globalStyles.clickable}`}
                            onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e)}
                        />
                            <Menu
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                            >
                                {(breakPoints.smallScreen ? actionMenuItemForMobileScreen : actionMenuItemForWorkflow).map((item, index) => {
                                    return (
                                        <MenuItem
                                            className={globalStyles.menuItemStyle}
                                            key={index}
                                            sx={{ fontSize: "14px", fontWeight: "500" }}
                                            onClick={(e) => { e.stopPropagation(); handleMenuClose(); item.action() }} 
                                            disabled={item.isDisable ?? false}
                                        >
                                            <span>
                                                {item.label}
                                            </span>
                                            {item.isDisable && item.disabledReason &&
                                                <GlobalTooltip arrow placement='left' title={item.disabledReason}>
                                                    <Grid item className={styles.disabledMenuItemInfoIcon}>
                                                        <IconsColor fillColor={primaryColor} iconName="info" height={"16"} width={"16"} />
                                                    </Grid>
                                                </GlobalTooltip>
                                            }
                                        </MenuItem>
                                    );
                                })}
                            </Menu>
                    </Grid>
                </Grid> 

                {flagResetChatConfirmationPopup && 
                    <GlobalPopUp
                        open={flagResetChatConfirmationPopup}
                        onClose={() => { setFlagResetChatConfirmationPopup(false); }}
                        handleClose={() => { setFlagResetChatConfirmationPopup(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "400px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "500px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <ResetChatConfirmationPopup
                            publishChatbot={publishChatbot}
                        />
                    </GlobalPopUp>
                } 

                {flagDeletePostDeploymentTriggerWarning && 
                    <GlobalPopUp
                        open={flagDeletePostDeploymentTriggerWarning}
                        onClose={() => { setFlagDeletePostDeploymentTriggerWarning(false); }}
                        handleClose={() => { setFlagDeletePostDeploymentTriggerWarning(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "600px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "700px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <DeletePostDeploymentTriggerWarningPopup
                            setFlagDeletePostDeploymentTriggerWarning={setFlagDeletePostDeploymentTriggerWarning} 
                            listOfDeletedSteps={listOfDeletedSteps} 
                            publishChatbot={publishChatbot}
                        />
                    </GlobalPopUp> 
                }

                {flagValidationWarningInStep && 
                    <GlobalPopUp
                        open={flagValidationWarningInStep}
                        onClose={() => { setFlagValidationWarningInStep(false); }}
                        handleClose={() => { setFlagValidationWarningInStep(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "600px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "700px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <MissingSaveVariableActionValidationPopup
                            setFlagValidationWarningInStep={setFlagValidationWarningInStep} 
                            flagMissingTemplateActionWarning={flagMissingTemplateActionWarning}
                            setFlagMissingTemplateActionWarning={setFlagMissingTemplateActionWarning}
                            listOfInvalidFlowValidationStep={listOfInvalidFlowValidationStep}
                        />
                    </GlobalPopUp>
                }

                {flagCustomVariableTablePopup && 
                    <GlobalPopUp
                        open={flagCustomVariableTablePopup}
                        onClose={() => { setFlagCustomVariableTablePopup(false); }}
                        handleClose={() => { setFlagCustomVariableTablePopup(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "750px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "850px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        height='90%'
                        overflow="hidden"
                    >
                        <CustomVariableTable />
                    </GlobalPopUp>
                }

                {flagShowImportChatbotPopup && 
                    <GlobalPopUp
                        open={flagShowImportChatbotPopup}
                        onClose={() => { setFlagShowImportChatbotPopup(false); }}
                        handleClose={() => { setFlagShowImportChatbotPopup(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "650px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "650px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <ImportRuleBasedChatbotPopup
                            onClose={() => setFlagShowImportChatbotPopup(false)}
                        />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default WorkflowActionBlock
